var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 4.25H12.5V3H7.5V4.25ZM2.5 6.75H3.75V17.375C3.75 17.5408 3.81585 17.6997 3.93306 17.8169C4.05027 17.9342 4.20924 18 4.375 18H15.625C15.7908 18 15.9497 17.9342 16.0669 17.8169C16.1842 17.6997 16.25 17.5408 16.25 17.375V6.75H17.5V5.5H2.5V6.75ZM7.5 9.25V14.25H8.75V9.25H7.5ZM11.25 9.25V14.25H12.5V9.25H11.25Z",
    fill: "#FF5C77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRedIcon);
export default __webpack_public_path__ + "static/media/delete-red-icon.1373a56f7f64355cf32d6dcfeaec8965.svg";
export { ForwardRef as ReactComponent };